"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var lodash_1 = require("lodash");
var operators_1 = require("rxjs/operators");
var abstract_destruction_subject_1 = require("../utils/abstract-destruction-subject");
var PageRuntimeComponentLoaderService = /** @class */ (function (_super) {
    __extends(PageRuntimeComponentLoaderService, _super);
    function PageRuntimeComponentLoaderService(moduleRegistryServicePage, compiler) {
        var _this = _super.call(this) || this;
        _this.moduleRegistryServicePage = moduleRegistryServicePage;
        _this.compiler = compiler;
        return _this;
    }
    PageRuntimeComponentLoaderService.prototype.initComponent = function (container, selector, componentContextMapping, resolvedComponentTemplate, dynamicContext) {
        var _this = this;
        if (dynamicContext === void 0) { dynamicContext = {}; }
        if (lodash_1.isNil(container)) {
            return;
        }
        container.clear();
        this.moduleRegistryServicePage
            .findModuleAndControlType(selector)
            .pipe(operators_1.map(function (data) { return data.moduleType; }), operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (moduleType) {
            var providers = moduleType['__annotations__'][0].providers;
            _this.createComponentAsync(moduleType, providers, resolvedComponentTemplate, componentContextMapping, container, dynamicContext);
        }, console.error);
    };
    PageRuntimeComponentLoaderService.prototype.createComponentAsync = function (containerModule, providers, resolvedComponentTemplate, componentContextMapping, container, dynamicContext) {
        if (dynamicContext === void 0) { dynamicContext = {}; }
        // tslint:disable-next-line:max-classes-per-file
        var cmpClass = /** @class */ (function () {
            function RuntimeComponent() {
            }
            Object.defineProperty(RuntimeComponent.prototype, "isSettingsActive", {
                get: function () {
                    return (dynamicContext.isSettingsActive &&
                        dynamicContext.isSettingsActive());
                },
                enumerable: true,
                configurable: true
            });
            return RuntimeComponent;
        }());
        var decoratedCmp = core_1.Component({
            template: resolvedComponentTemplate,
            providers: providers,
        })(cmpClass);
        // tslint:disable-next-line:max-classes-per-file
        var RuntimeComponentModule = /** @class */ (function () {
            function RuntimeComponentModule() {
            }
            RuntimeComponentModule = __decorate([
                core_1.NgModule({
                    declarations: [decoratedCmp],
                    imports: [forms_1.FormsModule, common_1.CommonModule, containerModule],
                })
            ], RuntimeComponentModule);
            return RuntimeComponentModule;
        }());
        this.compiler
            .compileModuleAndAllComponentsAsync(RuntimeComponentModule)
            .then(function (module) {
            var cmpRef = container.createComponent(module.componentFactories.find(function (f) { return f.componentType === decoratedCmp; }));
            var instance = cmpRef.instance;
            componentContextMapping.forEach(function (value, key) {
                Reflect.set(instance, key, value);
            });
        });
    };
    PageRuntimeComponentLoaderService = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Inject(idm_dynamic_layout_interpreter_1.pageModuleRegistryKey)),
        __metadata("design:paramtypes", [idm_dynamic_layout_interpreter_1.ModuleRegistryService,
            core_1.Compiler])
    ], PageRuntimeComponentLoaderService);
    return PageRuntimeComponentLoaderService;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.PageRuntimeComponentLoaderService = PageRuntimeComponentLoaderService;
//# sourceMappingURL=page-runtime-component-loader.service.js.map